import { IconButton, Presence, useBreakpointValue } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons';

import { useScrollPosition } from '@app/hooks';

export const ScrollTopButton = ({ isV7 }: { isV7?: boolean }) => {
    const showAboveMd = useBreakpointValue({
        base: false,
        lg: true,
    });
    const scrollPosition = useScrollPosition();

    const buttonStyles = {
        position: 'fixed' as const,
        bottom: 8,
        right: 12,
        width: '50px',
        height: '50px',
        borderRadius: 'full',
        zIndex: 'docked',
        alignItems: 'center',
        bgColor: isV7 ? undefined : 'white',
    };

    return showAboveMd ? (
        <Presence
            present={scrollPosition > window.innerHeight}
            animationName={{ _open: 'fade-in', _closed: 'fade-out' }}
            animationDuration="moderate"
            lazyMount
        >
            <IconButton
                {...buttonStyles}
                colorPalette={'brand'}
                variant={isV7 ? 'solid' : 'outline'}
                onClick={() => {
                    if (typeof window !== 'undefined') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }}
            >
                <IconsLinear.ArrowUp fontSize={'3xl'} />
            </IconButton>
        </Presence>
    ) : null;
};
